export default {"src":"/_next/static/image/public/images/ic_left_pagination_arrow.ce36faeaa47b58c16de929ffca7acb2e.svg","height":15,"width":8};